import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toThunkRejectValue } from "../../../../Common/isRequestCanceled";
import {
  AVG_SALE_VALUE,
  BASE_URL,
  REPORTS_BASE_URL,
  REPORTS_AVG_SALES_VALUE,
  IS_PY_GRAPHS,
} from "../../../../Constants/Config";
import { useAuthDetails } from "../../../../Common/cookiesHelper";

const initialState = {
  loading: true,
  avgSaleValueData: [],
  totalAvgSaleValue: 0,
  previousAvgSaleValue: 0,
  lastRequestPayload: null,
  error: "",
  isCancel: false,
};
let controller = null;

export const getAvgSaleValue = createAsyncThunk(
  "avgSaleValueChart/getAvgSaleValue.",
  async (data, { rejectWithValue }) => {
    const { userTypeData } = useAuthDetails();
    if (controller) {
      controller.abort();
    }

    // Create a new AbortController instance for the current request
    controller = new AbortController();
    try {
      const { token, ...otherUserData } = userTypeData;

      const requestData = { ...(data || {}) };
      const activeType =
        requestData?.activeType || requestData?.view_by || requestData?.date_type;
      const isWeek = String(activeType || "").toLowerCase() === "week";

      const dateInYYYYMMDD = (date) => {
        const year = date?.getFullYear();
        const month = String(date?.getMonth() + 1)?.padStart(2, "0");
        const day = String(date?.getDate())?.padStart(2, "0");
        return `${year}-${month}-${day}`;
      };

      if (isWeek) {
        // const result = [];
        // for (let i = 6; i >= 0; i--) {
        //   const d = new Date(requestData?.end_date);
        //   d.setDate(d.getDate() - i);
        //   const formatted = dateInYYYYMMDD(d);
        //   result.push(`${formatted}_${formatted}`);
        // }

        // const mostRecentDay =
        //   result?.[result.length - 1]?.split("_")?.[0] || requestData?.end_date;

        // if (mostRecentDay) {
        //   requestData.start_date = mostRecentDay;
        //   requestData.end_date = mostRecentDay;
        // }
        const minusOneDay = (dateStr) => {
          const date = new Date(dateStr);
          date.setDate(date.getDate());
          return date.toISOString().split("T")[0]; // YYYY-MM-DD
        };
        requestData["date_range"] = `${minusOneDay(requestData.start_date)}_${minusOneDay(requestData.end_date)}`;
        // delete requestData["new_date_range"];
      }
      const apiUrl =
        IS_PY_GRAPHS === true || IS_PY_GRAPHS === "true"
          ? REPORTS_BASE_URL + REPORTS_AVG_SALES_VALUE
          : BASE_URL + AVG_SALE_VALUE;
      const response = await axios.post(
        apiUrl,
        { ...requestData, ...otherUserData },
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
          signal: controller.signal,
        }
      );

      // console.log("avg sale value data: ", response);

      return response.data;
    } catch (error) {
      if (axios.isCancel(error) || error.name === "CanceledError") {
        return rejectWithValue({ isCanceled: true }); // Mark as canceled
      }
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

const avgSaleValueChartSlice = createSlice({
  name: "avgSaleValueChart",
  initialState,
  reducers: {
    clearAvgSaleValueChart: (state, action) => {
      state.loading = true;
      state.avgSaleValueData = [];
      state.totalAvgSaleValue = 0;
      state.previousAvgSaleValue = 0;
      state.error = "";
      state.isCancel = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAvgSaleValue.pending, (state, action) => {
      state.loading = true;
      state.isCancel = false;
      state.lastRequestPayload = action.meta?.arg || null;
    });
    builder.addCase(getAvgSaleValue.fulfilled, (state, action) => {
      state.loading = false;
      state.avgSaleValueData = action.payload?.filter_revenue_data || [];
      state.totalAvgSaleValue = action.payload?.total_revenue_data || 0;
      state.lastRequestPayload = action.meta?.arg || null;
      const requestActiveType = String(
        action.meta?.arg?.activeType ||
        action.meta?.arg?.view_by ||
        action.meta?.arg?.date_type ||
        ""
      ).toLowerCase();
      state.previousAvgSaleValue =
        requestActiveType === "week"
          ? action.payload?.previous_avg_sales_value || 0
          : 0;
      state.error = "";
      state.isCancel = false;
    });
    builder.addCase(getAvgSaleValue.rejected, (state, action) => {
      const isCanceled = action.payload?.isCanceled === true;
      state.loading = false;
      state.isCancel = isCanceled;
      state.error = action.error?.message || "";

      if (!isCanceled) {
        state.avgSaleValueData = [];
        state.totalAvgSaleValue = 0;
        state.previousAvgSaleValue = 0;
      }
    });
  },
});

export const { clearAvgSaleValueChart } = avgSaleValueChartSlice.actions;
export default avgSaleValueChartSlice.reducer;
